import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import LoadingIndication from '../../common/loading-indicator';
import AnimatedWrapper from '../../core/animated-wrapper';
import shareService from '../../../services/share';
import newslettersService from '../../../services/newsletters';
// import SmartAd from '../../ads/smart-ad';

import './newsletters-catalog.css';

class NewslettersCatalog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,
    };

    shareService.setupPage({ 
      title: `Newsletters Catalog`,
      isTitlePrefixOn: false,
      tags: [],
    });
  }

  componentDidMount() {
    newslettersService.getNewslettersTypes()
      .then((newslettersTypes) => {
        this.setState({
          isLoading: false,
          newslettersTypes,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }
  
  render() {
    let extraJSX;

    const { isLoading, isError, newslettersTypes } = this.state;

    if (isLoading) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      if (isError) {
        extraJSX = (
          <div>
            <p>There are no newsletters</p>
          </div>
        );
      }
      else {
        extraJSX = (
          <div className='newsletters-types'>
            {
              newslettersTypes.map(newsletter => 
                <div key={ `newsletter-type-${newsletter.universalTagName}` } className='little-grow-animation'>
                  <NewsletterType  {...newsletter} />
                </div>
              )
            }
          </div>
        );
      }
    }

    return (
      <section className='regular-page newsletters-catalog-container'>
        <h3 className='page-title'>NEWSLETTERS</h3>
        <hr className='title-separator' />

        { extraJSX }
      </section>
    );
  }
}

const NewsletterType = ({ universalTagName, name }) => {
  return (
    <div className='newsletter-type'>
      <Link to={ `/newsletters/ag/${universalTagName}`} title={name}>
        <img src={ `/images/newsletters/badges/${universalTagName}.png` } title={ name } />
      </Link>
    </div>
  )
};

const AnimatedNewsletters = AnimatedWrapper(NewslettersCatalog);
export default AnimatedNewsletters;